"use strict";
import { __exports as o } from "./index.es166.js";
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f;
function y() {
  if (f) return o;
  f = 1;
  var t = Symbol.for("react.transitional.element"), s = Symbol.for("react.fragment");
  function a(l, e, r) {
    var i = null;
    if (r !== void 0 && (i = "" + r), e.key !== void 0 && (i = "" + e.key), "key" in e) {
      r = {};
      for (var n in e)
        n !== "key" && (r[n] = e[n]);
    } else r = e;
    return e = r.ref, {
      $$typeof: t,
      type: l,
      key: i,
      ref: e !== void 0 ? e : null,
      props: r
    };
  }
  return o.Fragment = s, o.jsx = a, o.jsxs = a, o;
}
export {
  y as __require
};
//# sourceMappingURL=index.es132.js.map
